import {FaChevronCircleLeft} from "react-icons/fa";

import {AlertExtraData} from "@/lib/types/alerting.ts";
import {CheckStepDef} from "@/lib/types/checks.ts";
import {DownAlert} from "@/pages/alerting/components/details/DownAlert.tsx";
import {RCABrowserConsoleLog} from "@/pages/alerting/components/details/rca/RCABrowserConsoleLog.tsx";
import {RCACheckResults} from "@/pages/alerting/components/details/rca/RCACheckResults.tsx";
import {RCAPicture} from "@/pages/alerting/components/details/rca/RCAPicture.tsx";

interface RootCauseAnalysisProps {
  onGoBack: () => void;
  alertData: AlertExtraData;
  stepsDef: CheckStepDef[];
}

export const RootCauseAnalysis = ({onGoBack, stepsDef, alertData}: RootCauseAnalysisProps) => {
  const consoleLines = alertData.data?.console || [];
  const results = alertData?.data?.results || [];
  return (
    <div>
      <button
        type="button"
        aria-label="Go back to down alerts list"
        onClick={onGoBack}
        className="btn btn-link text-decoration-none float-end"
      >
        <FaChevronCircleLeft /> Go Back
      </button>
      <DownAlert alert={alertData.alert!} />
      {alertData.picture && <RCAPicture pictureURL={alertData.picture} />}
      {results.length > 0 && (
        <RCACheckResults
          results={results}
          stepsDef={stepsDef}
          network={alertData.data?.network || []}
          version={alertData.data?.version}
        />
      )}
      {consoleLines.length > 0 && <RCABrowserConsoleLog logs={consoleLines} />}
    </div>
  );
};
